import { logger } from '@tuic/logger';

/**
 * Tries given `request`. If it fails, given `errorMessage` is written to the console before the actual error is written.
 */
export const tryRequest = async <T>(
  request: () => Promise<T | undefined>,
  errorMessage: string,
) => {
  try {
    return await request();
  } catch (e) {
    logger.error(errorMessage);
    logger.error(e);
  }
};
